import { DecimalPipe, NgClass, NgFor, NgIf, DatePipe, SlicePipe } from '@angular/common'; // <-- Added SlicePipe
import { InvoiceserviceService } from '../../../Services/invoiceservice.service';
import { UserCustomerService } from '../../../Services/User/Customer/user-customer.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { NotificationService } from '../../../Services/notification.service';
import { GstInvoiceService } from '../../../Services/Invoice/gst-invoice.service';
import { WhatsappInstanceService } from '../../../Services/Whatsapp/whatsapp-instance.service';
import { AccountService } from '../../../Services/Accounts/account.service';
import { FirmSelectionService } from '../../../Services/firm-selection.service';
import { Subscription } from 'rxjs';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-customer-home',
  standalone: true,
  imports: [NgFor, NgIf, DecimalPipe, NgClass, DatePipe, FormsModule, SlicePipe],
  templateUrl: './customer-home.component.html',
})
export class CustomerHomeComponent implements OnInit, OnDestroy {
  activeTab: 'nongst' | 'gst' | 'transactions' = 'nongst';
  isLoading = false;
  isWhatsappSending = false;
  selectedInvoice: any = null;

  customerInfo: any = null;
  customerUdharList: any[] = [];
  gstInvoiceList: any[] = [];

  totalUdhar = 0;
  totalPaid = 0;
  totalMetalDue = 0;
  totalMetalDuePaid = 0;
  pendingInvoiceCount = 0;
  customerId!: number;
  currentPage: number = 1;
  apiError: string = '';
  isSubmitting = false;
  // 2. Add these new variables for history
  transactions: any[] = [];
  isLoadingTransactions = false;
  fromDate: string = '';
  toDate: string = '';
  totalTransactions = 0;
  pageSize = 10;
  // Note: Rename your existing currentPage to nongstPage if needed, or use historyCurrentPage
  historyCurrentPage = 1;
  paymentAccounts: any[] = [];
  private firmSub!: Subscription;
  private currentFirmId: any = null;

  get todayISO(): string {
    return new Date().toISOString().split('T')[0];
  }

  get customerMobile(): string {
    return String(this.customerInfo?.mobilenumber ?? '').trim();
  }

  get customerName(): string {
    return String(this.customerInfo?.name ?? '').trim();
  }


  // Modal State
  showPaymentModal = false;
  paymentData = {
    date: new Date().toISOString().split('T')[0],
    method: 'cash',
    cash_amount: 0,
    cash_acc_id: '',
    bank_amount: 0,
    bank_acc_id: '',
    card_amount: 0,
    card_acc_id: '',
    online_amount: 0,
    online_acc_id: '',
    metal_weight: 0,
    gross_weight: 0,
    purity: 0,
    metal_type: 'Silver',
    remarks: ''
  };

  cashAccounts: any[] = [];
  bankAccounts: any[] = [];
  cardAccounts: any[] = [];
  onlineAccounts: any[] = [];

  get totalCashPaid(): number {
    return (
      Number(this.paymentData.cash_amount || 0) +
      Number(this.paymentData.bank_amount || 0) +
      Number(this.paymentData.card_amount || 0) +
      Number(this.paymentData.online_amount || 0)
    );
  }

  get selectedMetalBalance(): number {
    if (!this.selectedInvoice) return 0;

    // 1. Try resource-mapped computed balance (from payUdhar response)
    if (this.selectedInvoice.balance_silver_wt !== undefined) {
      return Number(this.selectedInvoice.balance_silver_wt);
    }

    // 2. Try raw payload extraction (Source of truth in some responses)
    try {
      let payload = this.selectedInvoice.in_rate_cut_payload;
      if (payload) {
        if (typeof payload === 'string') payload = JSON.parse(payload);
        if (payload?.rows?.length) {
          const lastRow = payload.rows[payload.rows.length - 1];
          return Number(lastRow.finalBalance || 0);
        }
      }
    } catch (e) { }

    // 3. Fallback to raw database column
    return Number(this.selectedInvoice.in_balance_silver_wt || 0);
  }


  constructor(
    private invoiceService: InvoiceserviceService,
    private notificationService: NotificationService,
    private gstInvoiceService: GstInvoiceService,
    private whatsappInstanceService: WhatsappInstanceService,
    private userCustomerService: UserCustomerService,
    private accountService: AccountService,
    private firmSelectionService: FirmSelectionService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.customerId = Number(this.route.snapshot.paramMap.get('id'));
    this.loadCustomerDetails();
    this.loadCustomerUdhar();
    this.loadGstInvoices();

    this.firmSub = this.firmSelectionService.selectedFirmName$.subscribe((firm: any) => {
      if (firm?.id) {
        this.currentFirmId = firm.id;
        this.fetchAccounts(firm.id);
      }
    });
  }

  fetchAccounts(firmId: any) {
    this.accountService.getGroupedAccounts({ firm_id: firmId }).subscribe(res => {
      const grouped = res.data || {};
      const currentAssets = (grouped['Assets'] && grouped['Assets']['Current Assets']) || {};

      this.cashAccounts = currentAssets['Cash'] || [];
      this.bankAccounts = currentAssets['Bank Account'] || [];
      this.cardAccounts = currentAssets['Card Payment'] || [];
      this.onlineAccounts = currentAssets['Online Payment'] || [];

      // Default selections
      if (this.cashAccounts.length > 0) this.paymentData.cash_acc_id = this.cashAccounts[0].acc_id;
      if (this.bankAccounts.length > 0) this.paymentData.bank_acc_id = this.bankAccounts[0].acc_id;
      if (this.cardAccounts.length > 0) this.paymentData.card_acc_id = this.cardAccounts[0].acc_id;
      if (this.onlineAccounts.length > 0) this.paymentData.online_acc_id = this.onlineAccounts[0].acc_id;
    });
  }

  // 3. Reset pagination when switching tabs
  setActiveTab(tab: 'nongst' | 'gst' | 'transactions') {
    this.activeTab = tab;
    this.selectedInvoice = null;
    this.currentPage = 1;
    if (tab === 'transactions') {
      this.loadTransactions();
    }
  }


  ngOnDestroy(): void {
    if (this.firmSub) {
      this.firmSub.unsubscribe();
    }
  }

  loadCustomerDetails() {
    this.userCustomerService.getUserCustomerById(this.customerId).subscribe(res => {
      this.customerInfo = res.data;
      // this.totalUdhar = Number(this.customerInfo?.balance_due || 0);
    });
  }
  //  Add the function to fetch transaction history
  loadTransactions() {
    this.isLoadingTransactions = true;

    // Note: These keys MUST match your QueryFilter method names 
    // (e.g., filterByDateFrom looks for 'date_from')
    const params = {
      date_from: this.fromDate,
      date_to: this.toDate,
      limit: this.pageSize,
      page: this.historyCurrentPage
    };

    this.invoiceService.getTransactions(this.customerId, params).subscribe({
      next: (res: any) => {
        // Laravel Resource collections wrap data in a 'data' property
        this.transactions = res.data || [];
        // Pagination info is usually in 'meta'
        this.totalTransactions = res.meta?.total || 0;
        this.isLoadingTransactions = false;
      },
      error: (err) => {
        console.error(err);
        this.isLoadingTransactions = false;
      }
    });
  }

  clearTransactionsFilter() {
    this.fromDate = '';
    this.toDate = '';
    this.historyCurrentPage = 1;
    this.loadTransactions();
  }
  loadCustomerUdhar(): void {
    this.isLoading = true;
    this.invoiceService.getActiveUdharsbyCustomer(this.customerId).subscribe({
      next: (res: any) => {
        const payload = res?.data || {};
        this.customerUdharList = (payload?.data || []).map((inv: any) => ({
          ...inv,
          paid_amount: Number(inv.in_amount_paid || 0),
          display_total_amount: Number(inv.in_previous_amount || 0) + Number(inv.in_taxable_amount || 0)
        }));
        this.totalUdhar = Number(payload?.meta?.total_udhar || 0);
        this.totalPaid = Number(payload?.meta?.total_paid || 0);
        this.totalMetalDue = Math.abs(Number(payload?.meta?.total_metal_due || 0));
        this.totalMetalDuePaid = Number(payload?.meta?.total_metal_due_paid || 0);
        this.pendingInvoiceCount = payload?.meta?.pending_invoice_count ?? this.customerUdharList.length;
        this.isLoading = false;
      },
      error: () => this.isLoading = false
    });
  }

  loadGstInvoices(): void {
    const params = new HttpParams().set('customer_id', this.customerId.toString());
    this.gstInvoiceService.getGstInvoices(params).subscribe(res => {
      if (res.success) this.gstInvoiceList = res.data;
    });
  }

  openInvoice(invoice: any) {
    this.selectedInvoice = invoice;
  }

  goToPendingBilling() {
    this.router.navigate(['/sell-details-lot', this.customerId]);
  }

  goToUdharPayment() {

    if (!this.customerUdharList || this.customerUdharList.length === 0) {
      this.notificationService.showError('No invoices found.', 'Error');
      return;
    }

    const unpaidInvoice = this.customerUdharList.find(inv => {

      const cashDue = Number(inv.in_balance_due || 0);

      let metalDue = 0;

      try {
        let payload = inv.in_rate_cut_payload;

        if (typeof payload === 'string') {
          payload = JSON.parse(payload);
        }

        if (payload?.rows?.length) {
          const lastRow = payload.rows[payload.rows.length - 1];
          metalDue = Number(lastRow.finalBalance || 0);
        }

      } catch (e) {
        metalDue = 0;
      }

      return cashDue > 0 || metalDue > 0;

    });

    if (!unpaidInvoice) {
      this.notificationService.showError('No dues available for payment.', 'Info');
      return;
    }

    this.selectedInvoice = unpaidInvoice;

    // detect metal only case
    let metalDue = 0;

    try {
      let payload = unpaidInvoice.in_rate_cut_payload;

      if (typeof payload === 'string') {
        payload = JSON.parse(payload);
      }

      if (payload?.rows?.length) {
        const lastRow = payload.rows[payload.rows.length - 1];
        metalDue = Number(lastRow.finalBalance || 0);
      }

    } catch (e) {
      metalDue = 0;
    }

    if (Number(unpaidInvoice.in_balance_due || 0) === 0 && metalDue > 0) {
      this.paymentData.method = 'metal';
    }

    this.showPaymentModal = true;
  }


  closePaymentModal(): void {
    this.showPaymentModal = false;
    this.resetPaymentForm();
  }

  resetPaymentForm() {
    this.paymentData = {
      date: new Date().toISOString().split('T')[0],
      method: 'cash',
      cash_amount: 0,
      cash_acc_id: this.cashAccounts.length > 0 ? this.cashAccounts[0].acc_id : '',
      bank_amount: 0,
      bank_acc_id: this.bankAccounts.length > 0 ? this.bankAccounts[0].acc_id : '',
      card_amount: 0,
      card_acc_id: this.cardAccounts.length > 0 ? this.cardAccounts[0].acc_id : '',
      online_amount: 0,
      online_acc_id: this.onlineAccounts.length > 0 ? this.onlineAccounts[0].acc_id : '',
      metal_weight: 0,
      gross_weight: 0,
      purity: 0,
      metal_type: 'Silver',
      remarks: ''
    };
  }

  submitUdharPayment() {

    if (!this.selectedInvoice) {
      this.notificationService.showError('Please select an invoice.', 'Error');
      return;
    }

    let payload: any = {
      cash_amount: Number(this.paymentData.cash_amount || 0),
      bank_amount: Number(this.paymentData.bank_amount || 0),
      card_amount: Number(this.paymentData.card_amount || 0),
      online_amount: Number(this.paymentData.online_amount || 0),
      metal_wt: 0,
      cash_acc_id: this.paymentData.cash_acc_id,
      bank_acc_id: this.paymentData.bank_acc_id,
      card_acc_id: this.paymentData.card_acc_id,
      online_acc_id: this.paymentData.online_acc_id,
    };

    if (this.paymentData.method === 'metal') {
      payload.metal_wt = Number(this.paymentData.metal_weight || 0);
    }

    // 🔹 Basic validation
    if (this.totalCashPaid <= 0 && payload.metal_wt <= 0) {
      this.notificationService.showError('Enter valid payment amount.', 'Validation');
      return;
    }

    // =========================================================
    // ✅ FRONTEND OVERPAYMENT CHECK 
    // =========================================================

    if (
      this.paymentData.method === 'cash' &&
      this.totalCashPaid > this.totalUdhar
    ) {
      this.notificationService.showError(
        `Total amount ₹${this.totalCashPaid.toFixed(2)} cannot exceed total udhar ₹${this.totalUdhar.toFixed(2)}`,
        'Validation'
      );
      return;
    }

    if (
      this.paymentData.method === 'metal' &&
      payload.metal_wt > this.selectedMetalBalance
    ) {
      this.notificationService.showError(
        `Metal weight ${payload.metal_wt} GM cannot exceed balance ${this.selectedMetalBalance.toFixed(3)} GM`,
        'Validation'
      );
      return;
    }

    this.isSubmitting = true;

    this.invoiceService.payUdhar(this.selectedInvoice.in_id, payload)
      .subscribe({

        next: (res: any) => {

          this.isSubmitting = false;

          this.selectedInvoice.in_balance_due = res.data?.in_balance_due;
          this.selectedInvoice.in_balance_silver_wt = res.data?.in_balance_silver_wt;
          this.selectedInvoice.paid_amount = res.data?.in_amount_paid;

          this.loadCustomerUdhar();

          this.notificationService.showSuccess(
            res?.message || 'Payment recorded successfully.',
            'Success'
          );

          this.closePaymentModal();
        },

        error: (err: any) => {

          this.isSubmitting = false;

          let errorMessage = 'Something went wrong.';

          if (err?.error) {
            if (err.error.message && !err.error.errors) {
              errorMessage = err.error.message;
            } else if (err.error.errors) {
              const firstKey = Object.keys(err.error.errors)[0];
              errorMessage = err.error.errors[firstKey][0];
            }
          }

          this.notificationService.showError(errorMessage, 'Error');
        }

      });
  }

  calculateMetalWeight() {
    const gross = Number(this.paymentData.gross_weight) || 0;

    let purity = Number(this.paymentData.purity) || 0;

    // Clamp purity between 0–100
    if (purity > 100) purity = 100;
    if (purity < 0) purity = 0;

    this.paymentData.purity = purity;

    const result = (gross * purity) / 100;

    this.paymentData.metal_weight = Number(result.toFixed(2));
  }
  //redirected for invoice route
  goToInvoice(id: number) {
    this.router.navigate(['/rough-estimate-invoice', id]);
  }

  async sendCustomerSummaryWhatsapp() {
    if (!this.customerMobile) {
      this.notificationService.showError('Customer mobile number not found.', 'WhatsApp');
      return;
    }

    const original = document.getElementById('customer-summary-print');
    if (!original) {
      this.notificationService.showError('Summary layout not found for PDF.', 'WhatsApp');
      return;
    }

    this.isWhatsappSending = true;

    try {
      // 1. Clone node for clean capture
      const clone = original.cloneNode(true) as HTMLElement;

      const A4_WIDTH_PX = 794;
      const A4_HEIGHT_PX = 1123;

      // 2. Setup clone container styling
      Object.assign(clone.style, {
        background: '#ffffff',
        position: 'fixed',
        left: '-99999px',
        top: '0',
        width: A4_WIDTH_PX + 'px',
        height: A4_HEIGHT_PX + 'px',
        margin: '0',
        padding: '0',
        boxSizing: 'border-box',
        color: '#000000' // Ensure default text is black
      });

      document.body.appendChild(clone);

      // 3. Fix Layout specific containers
      const outer = clone.querySelector('.outer-border-container') as HTMLElement;
      if (outer) {
        outer.style.width = '100%';
        outer.style.height = '100%';
        outer.style.boxSizing = 'border-box';
        outer.style.borderColor = '#006269'; // Standard Hex
      }

      const inner = clone.querySelector('.inner-print-container') as HTMLElement;
      if (inner) {
        inner.style.height = '100%';
        inner.style.display = 'flex';
        inner.style.flexDirection = 'column';
      }

      const footer = clone.querySelector('.invoice-footer') as HTMLElement;
      if (footer) {
        footer.style.marginTop = 'auto';
      }

      // 4. THE CRITICAL FIX: Sanitize ALL elements for html2canvas
      // We must manually overwrite any oklch/oklab values with standard Hex/RGB
      const allElements = clone.querySelectorAll('*');
      allElements.forEach((el) => {
        const node = el as HTMLElement;
        // Get computed style from the ORIGINAL element (not the clone) 
        // to see what colors are being applied by CSS
        const computed = window.getComputedStyle(el);

        const properties = ['color', 'backgroundColor', 'borderColor', 'fill', 'stroke'];

        properties.forEach(prop => {
          const value = (computed as any)[prop];
          if (value && (value.includes('oklch') || value.includes('oklab'))) {
            // If it's a "brand" color (your teal/green), use your specific Hex
            // Otherwise, default to black for text and white for backgrounds
            if (prop === 'backgroundColor') {
              node.style.backgroundColor = '#ffffff';
            } else if (prop === 'color' || prop === 'borderColor') {
              node.style.setProperty(prop, '#006269', 'important');
            } else {
              node.style.setProperty(prop, '#000000', 'important');
            }
          }
        });

        // Remove modern shadows which also cause issues in html2canvas
        node.style.boxShadow = 'none';
        node.style.filter = 'none';
      });

      // 5. Generate Canvas
      const canvas = await html2canvas(clone, {
        scale: 2,
        useCORS: true,
        backgroundColor: '#ffffff',
        // This helper function inside html2canvas helps catch any missed elements
        onclone: (clonedDoc) => {
          const style = clonedDoc.createElement('style');
          style.innerHTML = `* { color-scheme: light !important; }`;
          clonedDoc.head.appendChild(style);
        }
      });

      document.body.removeChild(clone);

      // 6. PDF Generation
      const imgData = canvas.toDataURL('image/jpeg', 0.85);
      const pdf = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'a4',
        compress: true
      });

      pdf.addImage(imgData, 'JPEG', 0, 0, 210, 297, undefined, 'FAST');

      const blob = pdf.output('blob');
      const reader = new FileReader();

      reader.onloadend = () => {
        const payload = {
          invoice_id: `CS-${this.customerId}-${this.todayISO}`,
          pdf: reader.result,
          mobile: this.customerMobile,
          message: `Meena Sterling Silver.\n\nCustomer summary attached for ${this.customerName || '-'} (${this.customerMobile}).\n\nTotal Udhar: ₹ ${this.totalUdhar.toFixed(2)}\nTotal Paid: ₹ ${this.totalPaid.toFixed(2)}\nMetal Due: ${this.totalMetalDue.toFixed(2)} GM\nMetal Paid: ${this.totalMetalDuePaid.toFixed(2)} GM\n\nNote: This is an auto-generated summary from Meena Silver ERP.\nThank you for choosing Meena Sterling Silver.`
        };

        this.gstInvoiceService.sendGstInvoiceToWhatsapp(payload).subscribe({
          next: (res: any) => {
            if (!res?.success) {
              this.notificationService.showError('PDF send failed', 'WhatsApp');
            } else {
              this.notificationService.showSuccess('Customer summary PDF sent', 'WhatsApp');
            }
            this.isWhatsappSending = false;
          },
          error: (err) => {
            const msg = err?.error?.message || 'PDF send failed';
            this.notificationService.showError(msg, 'WhatsApp');
            this.isWhatsappSending = false;
          }
        });
      };

      reader.readAsDataURL(blob);
    } catch (e) {
      console.error('Customer summary PDF error:', e);
      this.notificationService.showError('Failed to generate PDF summary.', 'WhatsApp');
      this.isWhatsappSending = false;
    }
  }

  downloadHistoryPDF(): void {
    this.downloadHistoryPDFAsync();
  }

  async downloadHistoryPDFAsync(): Promise<void> {
    this.isLoading = true;

    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4',
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const datePipe = new DatePipe('en-IN');
    const decimalPipe = new DecimalPipe('en-IN');

    /* ---------- HEADER ---------- */
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(16);
    doc.setTextColor(193, 151, 37); // Gold theme
    doc.text('Customer Udhar History', pageWidth / 2, 16, { align: 'center' });

    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(100);
    doc.text(`Customer: ${this.customerName}`, 14, 25);
    doc.text(`Mobile: ${this.customerMobile}`, 14, 30);

    doc.text(
      `Generated on: ${new Date().toLocaleString()}`,
      pageWidth - 14,
      25,
      { align: 'right' }
    );

    const period = (this.fromDate || 'All') + ' to ' + (this.toDate || 'Present');
    doc.text(`Filter Period: ${period}`, pageWidth - 14, 30, { align: 'right' });

    /* ---------- TABLE ---------- */
    const headers = [
      { header: 'No.', dataKey: 'no' },
      { header: 'Date', dataKey: 'date' },
      { header: 'Comments/Remarks', dataKey: 'comments' },
      { header: 'Cash Received', dataKey: 'cash' },
      { header: 'Metal Received', dataKey: 'metal' },
      { header: 'Status', dataKey: 'status' },
    ];

    const body = this.transactions.map((item, index) => {
      return {
        no: index + 1,
        date: datePipe.transform(item.utr_date, 'dd MMM yyyy'),
        comments: item.utr_comments || '-',
        cash: item.utr_cash_received > 0 ? `Rs. ${decimalPipe.transform(item.utr_cash_received, '1.2-2')}` : '—',
        metal: item.utr_fine_wt > 0 ? `${decimalPipe.transform(item.utr_fine_wt, '1.3-3')} GM` : '—',
        status: item.utr_status ? item.utr_status.toUpperCase() : 'N/A'
      };
    });

    autoTable(doc, {
      columns: headers,
      body: body,
      startY: 38,
      margin: { left: 10, right: 10 },
      theme: 'grid',
      horizontalPageBreak: false,
      rowPageBreak: 'auto',

      styles: {
        fontSize: 8,
        cellPadding: 2,
        overflow: 'linebreak',
        valign: 'middle',
      },

      headStyles: {
        fillColor: [193, 151, 37],
        textColor: 255,
        halign: 'center',
        fontSize: 9,
        fontStyle: 'bold',
      },

      columnStyles: {
        no: { cellWidth: 10, halign: 'center' },
        date: { cellWidth: 25 },
        cash: { halign: 'right', cellWidth: 30 },
        metal: { halign: 'right', cellWidth: 30 },
        status: { halign: 'center', cellWidth: 25 },
      },

      alternateRowStyles: {
        fillColor: [245, 245, 245],
      },

      didDrawPage: (data) => {
        doc.setFontSize(8);
        doc.setTextColor(150);
        // ✅ FIXED: Using (doc as any).getNumberOfPages() to avoid TS error
        doc.text(
          `Page ${(doc as any).getNumberOfPages()}`,
          pageWidth / 2,
          pageHeight - 10,
          { align: 'center' }
        );
      },
    });

    doc.save(`History_${this.customerName.replace(/\s+/g, '_')}_${this.todayISO}.pdf`);
    this.isLoading = false;
    this.notificationService.showSuccess('Udhar history downloaded.', 'Success');
  }
}